import React from "react";
import ct from "class-types.macro";
export default function PlusPriceBox({
  children,
  isBrandAd
}: {
  children: React.ReactNode;
  isBrandAd?: boolean;
}) {
  return <div className={ct("bg-gradient-to-t", "from-light-blue-100", "to-light-blue-300", "border-blue-500", "rounded", "border-solid", "border", "my-0", isBrandAd ? "py-1 px-2" : "p-1")} data-sentry-component="PlusPriceBox" data-sentry-source-file="PlusPriceBox.tsx">
      {children}
    </div>;
}